<template>
  <VDialog
    ref="globalErrorDialog"
    v-model="isDialogOpen"
    width="425"
    persistent
    outlined
  >
    <VCard>
      <VCardTitle class="pb-0">
        <span class="heading-6">
          {{ title }}
        </span>
      </VCardTitle>
      <VCardText class="pb-0">
        <div class="d-flex align-items-center justify-content-center py-6">
          <img
            :src="require('@slg/web-customer-shared/src/assets/img/sad-cat.svg')"
            :alt="$t('imageAlt.errorIllustration')"
          >
        </div>
        <div
          v-if="errorMessage"
          class="d-flex"
        >
          <span class="body-1 textSecondary--text">
            {{ errorMessage }}
          </span>
        </div>
      </VCardText>
      <VCardActions class="pb-4 pt-6">
        <VBtn
          class="w-100 shadow-none"
          color="brandingPrimary"
          dark
          @click="okHandler"
        >
          <span class="button">
            {{ $t('general.ok') }}
          </span>
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script lang="ts">
export default {
  name: 'SGlobalErrorDialog',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouteRef, useRouter } from '../../composables';

const emit = defineEmits(['trackGtmEventServerErrorOccurred']);

const route = useRouteRef();
const router = useRouter();

const isDialogOpen = ref(false);
const resolve = ref(null);
const errorMessage = ref('');
const title = ref('');
const isRedirectNeeded = ref(true);
const params = ref<Record<string, unknown>>({});

function open(options: {
  errorMessage: string;
  title: string;
  isRedirectNeeded: boolean;
  additionalParams?: Record<string, unknown>;
}) {
  isDialogOpen.value = true;
  errorMessage.value = options.errorMessage;
  title.value = options.title;
  isRedirectNeeded.value = options.isRedirectNeeded;
  params.value = { ...route.value.params, ...options.additionalParams };
}

function okHandler() {
  emit('trackGtmEventServerErrorOccurred');
  isDialogOpen.value = false;
  if (route.value.name !== 'Booking' && isRedirectNeeded.value) {
    router.push({ name: 'Booking', params: params.value });
  }
}

defineExpose({
  open,
});
</script>

<style scoped lang="scss">

</style>
